import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import {
    getItemModelBuyNowAvailable,
    getItemModelIsLocked,
    getItemModelIsPassed,
    getItemModelIsSold,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { getLiveItemStatusOpen } from '@/redux/modules/liveItemStatus';
import { ItemCardNavigationTrigger } from '@/utils/amplitude/analytics';
import { useAppSelector } from '@/redux/hooks';
import ItemCardShortDate from '@/components/GridItemCard/Card/components/ItemCardShortDate/ItemCardShortDate';
import styled from 'styled-components';

export type CardInfoProps = {
    itemId: number;
    onNavigate?: (trigger: ItemCardNavigationTrigger) => void;
};

const CardInfo = ({ itemId, onNavigate }: CardInfoProps) => {
    const buyNowAvailable = useAppSelector((state) => getItemModelBuyNowAvailable(state, itemId));
    const isLotOpen = useAppSelector((state) => getLiveItemStatusOpen(state, itemId));
    const isPassed = useAppSelector((state) => getItemModelIsPassed(state, itemId));
    const isSold = useAppSelector((state) => getItemModelIsSold(state, itemId));
    const isLocked = useAppSelector((state) => getItemModelIsLocked(state, itemId));
    const isPending = isLocked && !isPassed && !isSold && !isLotOpen;

    // Displays Card Info in item cards (not Timed Plus) on Category and Search Pages.
    return (
        <CardInfoSection>
            <StyledDateInfo>
                {buyNowAvailable ? (
                    <BodySecondary color="secondary">
                        <FormattedMessage id="buy_now" />
                    </BodySecondary>
                ) : (
                    <ItemCardShortDate
                        itemId={itemId}
                        onNavigate={onNavigate}
                        showOnlyYear={isSold || isPassed || isPending}
                    />
                )}
            </StyledDateInfo>
        </CardInfoSection>
    );
};

export default CardInfo;

const CardInfoSection = styled.section`
    grid-area: iteminfo;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xs};
`;

const StyledDateInfo = styled.span`
    line-height: 18px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        width: 100%;
        white-space: nowrap;
    }

    @media (max-width: 375px) {
        width: unset;
    }
`;
